module.exports = __webpack_public_path__ + "static/assets/de5de83488458d53d0f3181b9a39e802.svg";